import React, { useEffect, useState } from "react";
import { Avatar, Image, ThemeIcon } from "@mantine/core";
import { IconUsers } from "@tabler/icons-react";
import ComboboxDropdown from "./combobox-dropdown";
import WineMark from "./wine-mark";
import FintechLogo from "../assets/fintech_logo.png";
import Acme from "../assets/acme-logo.png";
import { useGlobal } from "../context/global-context";
export default function ClientApplicationToggle() {
  const { globalState, setContextValue } = useGlobal();

  const [selectedClientApp, setSelectedClientApp] = useState("");

  // Effect to load the initial state from localStorage when component mounts
  useEffect(() => {
    const storedApp = localStorage.getItem("selectedClientApp");
    if (storedApp) {
      setSelectedClientApp(storedApp);
      setContextValue("selectedClientApp", storedApp);
      if (storedApp === "/kids-games") {
        setContextValue("journey", "coppa_only");
        setContextValue("journeyTitle", "Data Match COPPA");
      } else {
        setContextValue("journey", "modularAV");
        setContextValue("journeyTitle", "ID Document with Express Options");
      }
    }
  }, []);

  const handleClientApplicationChange = (value) => {
    // Update local state
    setSelectedClientApp(value);
    // Save to localStorage to persist across sessions
    localStorage.setItem("selectedClientApp", value);
    setContextValue("selectedClientApp", value);
    if (value === "/kids-games") {
      setContextValue("journey", "coppa_only");
      setContextValue("journeyTitle", "Data Match COPPA");
    } else {
      setContextValue("journey", "modularAV");
      setContextValue("journeyTitle", "ID Document with Express Options");
    }
  };

  const data = [
    {
      label: "Age Restricted Commerce Demo",
      value: "/wine",
      description: "Sample online wine store",
      emoji: <WineMark size={44} />,
      selected: <WineMark size={36} label="Age Restricted Commerce Demo" />,
    },
    {
      label: "Financial Services Demo",
      value: "/register",
      description: "Fintech app with identity verification",
      emoji: <Image radius="lg" src={Acme} fit={"contain"} w={55} />,
    },
    {
      label: "Social Media Demo",
      value: "/kids-games",
      description: "Social media with age verification",
      emoji: (
        <ThemeIcon size={55} radius="xl" color="blue" variant="light">
          <IconUsers size={30} />
        </ThemeIcon>
      ),
    },
  ];

  return (
    <ComboboxDropdown
      withBorder={false}
      data={data}
      defaultValue={globalState.selectedClientApp}
      onChange={handleClientApplicationChange}
    />
  );
}
